import { itemmap } from 'data/items'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import WrongItem from '../WrongItem'
import { ChartFrame } from 'components/ChartFrame'
import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'

const UserMistakes = ({
  wrongAnswers,
  isMobile = false,
  colorMode = 'light',
}: {
  wrongAnswers: Answer[]
  isMobile?: boolean
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const [wrongItems, setWrongItems] = useState<Item[] | undefined>()
  const [showAll, setShowAll] = useState(false)
  useEffect(() => {
    if (!wrongAnswers) return
    const wrongItems = wrongAnswers
      .map((answer) => {
        const item = itemmap[answer.item]
        return item
      })
      .filter((f) => f)
    if (!wrongItems) return
    setWrongItems(wrongItems)
  }, [wrongAnswers])

  var show_always = isMobile ? 2 : 4

  return (
    <>
      <TextWidth>
        <ChartFrame
          style={{ marginBottom: 0 }}
          lang='de'
          title={
            wrongAnswers.length > 1
              ? ' Diese  ' +
                wrongAnswers.length +
                ' Produkte haben Sie falsch zugeordnet'
              : ' Dieses Produkt haben Sie falsch zugeordnet.'
          }
          lead={
            wrongItems ? (
              <>
                Mühe {wrongItems.length > 1 ? 'bereiten' : 'bereitet'} Ihnen{' '}
                {wrongItems.length > 5 ? 'unter anderem' : ''}{' '}
                <b>{listItems(wrongItems.slice(0, 5))}</b>. Hier einige
                Informationen zum richtigen Entsorgen dieser Produkte.
              </>
            ) : undefined
          }
        ></ChartFrame>
      </TextWidth>
      <TextWidthExtended>
        <UserMistakesContainer
          style={{
            backgroundColor: colorMode === 'dark' ? 'transparent' : undefined,
          }}
        >
          <ContentContainer
            showAll={wrongAnswers.length <= show_always ? true : showAll}
            colorMode={colorMode}
            style={{
              maxHeight:
                wrongAnswers.length >= show_always
                  ? '22200px'
                  : showAll
                  ? '9500px'
                  : undefined,
            }}
          >
            {wrongAnswers &&
              wrongAnswers
                .sort((a, b) => {
                  return a.answer.localeCompare(b.answer)
                })
                .slice(0, showAll ? undefined : show_always)
                .map((answer: Answer) => {
                  return (
                    <WrongItem
                      item={itemmap[answer.item]}
                      user={answer}
                      colorMode={colorMode}
                    />
                  )
                })}
          </ContentContainer>
          <>
            {wrongAnswers.length > show_always && (
              <MoreButtonContainer showAll={false}>
                <MoreButton onClick={() => setShowAll(!showAll)}>
                  {showAll ? 'Weniger zeigen' : 'Alle anzeigen'}
                </MoreButton>
              </MoreButtonContainer>
            )}
          </>
        </UserMistakesContainer>
      </TextWidthExtended>
    </>
  )
}

const EvaluationText = styled.div`
  margin-bottom: 30px;
  font-family: var(--font-serif);

  @media screen and (max-width: 711px) {
    font-size: 17px;
    line-height: 28px;
  }
`
const UserMistakesContainer = styled.div`
  background-color: var(--beige-bright-1);
  background-color: var(--site-background);
  -webkit-box-shadow: 0px 5px 22px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 5px 22px 0px rgba(0, 0, 0, 0.15);
  color: #fff;
  color: var(--brandblue-main);
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 45px;
  padding-bottom: 0;
  /* margin-bottom: 60px; */
  @media screen and (max-width: 711px) {
    padding: 10px;
  }
`
const ContentContainer = styled.div<{
  showAll: boolean
  colorMode: 'light' | 'dark' | undefined
}>`
  max-height: 700px;
  overflow-y: hidden;
  transition: max-height 0.2s ease-in-out;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  position: relative;
  padding-bottom: 15px;
  &::before {
    content: '';
    display: inline-block;
    width: 100%;
    height: 120px;
    position: absolute;
    bottom: 0px;
    left: 0;

    background: ${(props) =>
      props.showAll
        ? 'transparent'
        : props.colorMode == 'dark'
        ? 'linear-gradient(0deg,rgba(18, 18, 18, 1) 10%,rgba(18, 18, 18, 0) 100%);'
        : 'linear-gradient(0deg,rgba(255, 255, 255, 1) 10%,rgba(255, 255, 255, 0) 100%);'};
  }
`

const MoreButtonContainer = styled.div<{ showAll: boolean }>`
  width: 100%;
  text-align: center;
  /* margin-top: 30px; */
  position: relative;
`

const MoreButton = styled.button`
  /* color: var(--beige-bright-3); */
  background-color: transparent;
  /* background-color: var(--beige-main);
  background-color: var(--red-dark-2); */
  color: var(--text-color);
  border: 0;
  font-weight: 700;
  font-size: 18px;
  padding: 30px;
  padding-bottom: 15px;
  &:hover {
    cursor: pointer;
  }
`
/*

 &::before {
    content: '';
    display: inline-block;
    width: 100%;
    height: 80px;
    position: absolute;
    top: -80px;
    left: 0;
    border-bottom: 1px solid var(--text-color);
    
    background: ${(props) =>
      props.showAll ? 'transparent' : 'rgb(239, 236, 224)'};
   
        background: ${(props) =>
          props.showAll
            ? 'transparent'
            : 'linear-gradient(0deg,rgba(239, 236, 224, 0.9) 0%,rgba(239, 236, 224, 0) 100%);'};
      }

      */
const Title = styled.div`
  font-size: 22px;
  font-weight: 700;
  width: 100%;
  text-align: center;
  line-height: 1.4em;
  padding-top: 10px;
  margin-bottom: 8px;
  margin-bottom: 30px;
`

function listItems(items: Item[] | undefined) {
  var list = items?.map(
    (item, i) =>
      item.artikel_de +
      ' ' +
      item.name_de +
      (i === items.length - 2 ? ' oder ' : i === items.length - 1 ? '' : ', ')
  )
  return list?.join('')
}

export default UserMistakes
